if (!customElements.get('product-as-variant')) {
  customElements.define(
    'product-as-variant',
    class ProductAsVariant extends HTMLElement {
      constructor() {
        super();

        this.ignore_case = Debutify.widgets.product_as_variants.settings.ignore_swatch_case_product_as_variant;

        this.currentProduct = this.dataset.currentProduct;

        this.swatches = Debutify.widgets['product_as_variants']['blocks'];

        this.swatchesConfig = Debutify.widgets['product_as_variant_configurations'];

        if (!this.currentProduct || !this.swatches) {
          this.remove();
          return;
        }

        this.init();
      }

      parseValue(value) {
        if (this.ignore_case) {
          return value.toLowerCase().trim();
        } else {
          return value.trim();
        }
      }

      init() {
        const matchingSwatchIndex = this.findMatchingSwatch();
        if (matchingSwatchIndex !== -1) {
          this.prepareValueToProductMap(matchingSwatchIndex);

          const uniqueOptions = this.getUniqueOptions(matchingSwatchIndex);

          let generatedHTML = '';

          if (this.ignore_case) {
            this.swatchesConfig = Object.fromEntries(
              Object.entries(this.swatchesConfig).map(([key, value]) => [key.toLowerCase(), value])
            );
          }

          const selectedValues = this.matchingBlock.values.split(':').map((value) => this.parseValue(value));

          for (const [optionName, values] of Object.entries(uniqueOptions)) {
            let selected_value = '';

            let valuesHTML = '';
            values.forEach((value) => {
              const id = this.parseValue(`${optionName}-${value}`.replace(/\s+/g, '-'));
              let background = '';

              const option_value = this.parseValue(value);

              const option_background = this.swatchesConfig[option_value];
              if (option_background) {
                if (option_background.includes('.')) {
                  background = `url(${option_background})`;
                } else {
                  background = option_background;
                }
              }

              selected_value = selectedValues.includes(this.parseValue(value)) ? value : selected_value;

              valuesHTML += this.valuesTemplate()
                .replace(/{id}/g, id)
                .replace(/{option_name}/g, optionName)
                .replace(/{value}/g, value)
                .replace(/{background}/g, background)
                .replace(/{checked}/g, selectedValues.includes(this.parseValue(value)) ? 'checked' : '')
                .replace(/{pill_class}/g, background ? '' : ' swatch--pill');
            });

            generatedHTML += this.optionTemplate()
              .replace(/{option_name}/g, optionName)
              .replace(/{selected_option}/g, selected_value || '') // Default to the first value
              .replace(/{values}/g, valuesHTML);
          }
          this.innerHTML = generatedHTML;

          const radios = this.querySelectorAll('.swatch-input__input');
          radios.forEach((radio) => {
            radio.addEventListener('change', this.onRadioChange.bind(this));
          });
        }
      }

      onRadioChange() {
        const selectedValues = [];
        const radios = this.querySelectorAll('.swatch-input__input');
        radios.forEach((radio) => {
          if (radio.checked) {
            selectedValues.push(radio.value);
          }
        });

        const selectedValue = selectedValues.join(':');

        const selectedProduct = this.swatchesByValues[selectedValue];

        if (selectedProduct) window.location.href = `/products/${selectedProduct}`;
      }

      findMatchingSwatch() {
        for (let i = 0; i < this.swatches.length; i++) {
          const swatch = this.swatches[i];
          const blockSettings = swatch.block_settings;

          this.matchingBlock = blockSettings?.find((block) => block.product === this.currentProduct);
          if (this.matchingBlock) {
            return i;
          }
        }

        return -1;
      }

      getUniqueOptions(selectedIndex) {
        const swatch = this.swatches[selectedIndex];
        if (!swatch || !swatch.option_names || !this.matchingBlock) return {};

        const optionNames = swatch.option_names.split(':');
        const optionsWithValues = {};

        optionNames.forEach((option) => {
          optionsWithValues[option] = [];
        });

        const matchingValues = this.matchingBlock.values.split(':').map((value) => value);

        Object.keys(this.swatchesByValues).forEach((key) => {
          const blockValues = key.split(':').map((value) => value);

          blockValues.forEach((value, index) => {
            const optionName = optionNames[index];

            if (optionName) {
              const isCompatible = blockValues.every((blockValue, i) => {
                if (i === index) return true;

                return this.parseValue(matchingValues[i]) === this.parseValue(blockValue);
              });

              if (isCompatible && !optionsWithValues[optionName].includes(value)) {
                optionsWithValues[optionName].push(value);
              }
            }
          });
        });

        return optionsWithValues;
      }

      prepareValueToProductMap(selectedIndex) {
        const swatch = this.swatches[selectedIndex];
        if (!swatch || !swatch.block_settings) return {};

        const valueToProductMap = {};

        swatch.block_settings.forEach((block) => {
          valueToProductMap[this.parseValue(block.values)] = block.product;
        });

        this.swatchesByValues = valueToProductMap;
      }

      optionTemplate() {
        return `<fieldset class="js product-form__input product-form__input--swatch"  data-option-name="{option_name}">
    <legend class="form__label">
      {option_name}:
      <span data-selected-value="">{selected_option}</span>
    </legend>
    {values} 
  </fieldset>
  `;
      }

      valuesTemplate() {
        return `<input type="radio" id="{id}" name="{option_name}-1" value="{value}" 
      class="swatch-input__input" data-product-url="" data-option-value-id="4358061326638" data-option-value="{value}"
      {checked}
    />
    <label for="{id}" title="{value}" class="swatch-input__label{pill_class}">
      <span class="swatch" style="--swatch--background: {background};"></span>
      <span class="value-title">{value}</span>
      <span class="visually-hidden label-unavailable">Variant sold out or unavailable</span
      >
    </label>`;
      }
    }
  );
}
